import APIController from "./APIController"
import { useWebSocket } from "../Context/WebSocketContext"
const TimeTrackingController = () =>{
    const {jsonRequest, getWorkspaceId} = APIController()
    const {isOnline} = useWebSocket()

    const getStatisticsEntries = async (startDate, endDate) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId || !isOnline) return null;
        const startISO = new Date(startDate).toISOString();
        const endISO = new Date(endDate).toISOString();
        const data = await jsonRequest(`/${workspaceId}/time_tracking?startTime=${startISO}&endTime=${endISO}`);
        return data;
    };

    const getUserEntries = async (startDate, endDate) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId || !isOnline) return null;
        const startISO = new Date(startDate).toISOString();
        const endISO = new Date(endDate).toISOString();
        const data = await jsonRequest(`/${workspaceId}/time_tracking/user?startTime=${startISO}&endTime=${endISO}`);
        return data;
    };

    const getSpecificUserEntries = async (identifier, startDate, endDate) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId || !isOnline) return null;
        const startISO = new Date(startDate).toISOString();
        const endISO = new Date(endDate).toISOString();
        const data = await jsonRequest(`/${workspaceId}/time_tracking/user/${identifier}?startTime=${startISO}&endTime=${endISO}`);
        return data;
    };

    return{
        getStatisticsEntries,
        getUserEntries,
        getSpecificUserEntries
    }
}
export default TimeTrackingController